<template lang="pug">
v-form#trfIntForm(ref="trfIntForm", @submit.prevent="doSave", lazy-validation)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Rekening",
          required,
          :rules="[(v) => !!v || 'Masukan no rekening']",
          append-outer-icon="mdi-magnify",
          @click:append-outer="doFindAccount"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Nama",
          required,
          :rules="[(v) => !!v || 'Inquiry No. Rekening']",
          readonly
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="trfIntForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FTransferInternalListForm",
  props: ["productId", "productGroup"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
      },
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doFindAccount() {
      this.list.description = "";
      this.$progress.show(true);
      this.$http
        .get("api/banking/valid-account", {
          params: {
            accountNumber: this.list.customerId,
          },
        })
        .then(
          (success) => {
            this.list.description = success.data.name;
          },
          (err) => {
            this.$message.error(err.response.data.message);
          }
        )
        .finally(() => this.$progress.show(false));
    },
    doReset() {
      if (this.$refs.trfIntForm) {
        this.$refs.trfIntForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
      };
    },
    doSave() {
      if (this.$refs.trfIntForm.validate()) {
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>